import React, { Component } from 'react';

import { useParams, useNavigate  } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import ReactJson from 'react-json-view';
import jsonImg from "../../common/images/json-file.svg";
const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
	
	return (
	  <WrappedComponent
	  {...props}
	  params={params}
	  navigate ={navigate}
	  // etc...
	  />
	);
	};
class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
		const tabId = (typeof props.params.ID === 'undefined') ? '' : props.params.ID;
		this.state = {
            tabId: tabId,
			tab_name:'',
			description:'',
			title:'',
			content:'',
			Loading:false,
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			selectedtype : '',
			selectedtypeValue : '',
			editid:0,
			image_preview:'',
			image_name:'',
			image:'',
			tabFolder:'',
			old_image:'',
			fileExtension:'',
			showCategoryDropdown:false,
			category_id:'',
			categorynamelist: [],
			selectedCategory:'',
			fileList: [],  // ✅ ensure this exists initially as an empty array
			selectedOption: null,
			tab_name: '',
			image_preview: '',
			image_name: '',
			isHidden: false,
			isCategory: false,
			categoryTitleInput: '',
			Loading: false,
			functionalEndpoints: false,
			existingFiles: [],   
  			json_previews: [],  
			json_files: [],    
			file_id:"",   
			oldJsonContent:''
			
		};
		// this.props.getCategoryDetailList(tabId);
		this.handleJsonEdit = this.handleJsonEdit.bind(this);
		var qs = require('qs');
		var catid = this.state.tabId;
		let admin_id = localStorage.getItem("admin_id");
			var qs = require('qs');
			var postObject = {             
			cat_id   :catid,
			admin_id :admin_id
		   
			};
		   
			axios.post(apiUrl + "jsonaifeed/listdetail", qs.stringify(postObject)).then(res => {
				if (res.data.status === 'success') {
					console.log(res.data.categories);  // 👈 check what is here
					const categoryData = res.data.categories[0];

					var endpoint_st;
					if(categoryData.endpoint === 'yes') {
							endpoint_st = true;	
					}	else {
						endpoint_st = false;	
					}	
					
					
					this.setState({
					categoryTitle: categoryData.category_title, 
					functionalEndpoints: endpoint_st,
					fileList: categoryData.files,
					existingFiles: categoryData.files,   
					isCategory: true,
					expanded: false
					});
				}
				});

		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);

    }
	  handleJsonEdit = (edit) => {
	
		  this.setState({ jsonContent: edit.updated_src });
	
		  var qs = require('qs');
		  const postObject = {
			file_name: this.state.editingFileName,
			edited_id :this.state.file_id,
			new_json_content:  edit.updated_src,
			old_json_content: JSON.stringify(this.state.oldJsonContent)
		  };
	
		
		 axios.post(apiUrl + "jsonaifeed/updateJsonFile", qs.stringify(postObject)).then(res => {
			  if (res.data.status === 'success') {
	
				$('.success_message').html('<div class="status_sucess"><h3>'+'JSON file updated successfully!'+'</h3></div>');
				setTimeout(
									function() {
										$('.success_message').html('');
									}
									.bind(this),
									3000
									);
				this.setState({ editMode: false });
			  } else {
				 $('.success_message').html('<div class="status_sucess"><h3>'+'JSON file updated successfully!'+'</h3></div>');
				alert('Failed to update JSON file.');
			  }
			})
			.catch((error) => {
			  console.error('Error updating JSON:', error);
			});
	  };
	  fetchJsonFileContent = (fileName,id) => {
	  
		 if (this.state.editingFileName === fileName) {
		  // if already open, close it
		  this.setState({ editingFileName: null });
		} else {
	  
		 var qs = require('qs');
		const postObject = { file_name: fileName };
		axios.post(apiUrl + "jsonaifeed/getJsonFile", qs.stringify(postObject))
		  .then(res => {
			try {
			  const parsedJson = JSON.parse(res.data.content);  
			  this.setState({
				jsonContent: parsedJson,
				editingFileName: fileName,
				file_id:id,
				oldJsonContent: res.data.content 
			  });
			} catch (error) {
			  alert("Invalid JSON format in file.");
			}
		  })
		  .catch(error => {
			console.error('Error fetching JSON content:', error);
		  });
		}
	  };

	  saveUpdatedJson = (fileName) => {
		var qs = require('qs');
		const postObject = {
		  file_name: fileName,
		  json_content: this.state.jsonContent,
		};
	  
		axios.post(apiUrl + "jsonaifeed/updateJsonFile", qs.stringify(postObject))
		  .then(res => {
			if (res.data.status === 'success') {
			  this.setState({
				isJsonDirty: false,
				successMessage: 'JSON saved successfully!'
			  });
	  
			  setTimeout(() => {
				this.setState({ successMessage: '' });
			  }, 3000);
			}
		  })
		  .catch(error => {
			console.error('Error saving JSON:', error);
		  });
	  };
    handleChange = selectedOption => {

        this.setState({selectedOption})
        this.setState({  selectedvalue : selectedOption.value});
    };
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
      if(name === 'tab_trending'){
      	this.setState({tab_trending_checked: !this.state.tab_trending_checked});
      }  		
    }

	componentDidMount() {
		document.title = PageTitle('Tab Edit');
		var admin_id = localStorage.getItem('admin_id');
			
    }

	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		reader.onloadend = () => {
		this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file
		});
		
		};
		reader.readAsDataURL(file);
	}

	handleCheckboxChange = (e) => {
  			this.setState({ functionalEndpoints: e.target.checked });
	};
        handleFormSubmit = () => {
			if(this.validateForm()){ 
				this.setState({Loading:true});
				
				const formPayload = this.state;
				var qs = require('qs');
				
			

				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					categoryTitle: formPayload.categoryTitle,
					functional_endpoints: this.state.functionalEndpoints ? 'yes' : 'no	',
					id: formPayload.tabId,
				};
				
				
				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}		   
				this.state.json_files.forEach((file) => {
    			formData.append('json_files[]', file);
  					});    
				axios.post(apiUrl+"jsonaifeed/edit",formData ).then(res => {
					if(res.data.status === "success"){	
						this.setState({Loading:false});
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
								setTimeout(
								function() {
									$('.success_message').html('');
                                   $('.success_message').html(this.props.navigate('/json'));
								}
								.bind(this),
								3000
								);
                               
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
					}
				});
			}
	}

	validateForm() {
		//const {admin_company_name,admin_fname} = this.state;
		
		const {categoryTitle,image} = this.state;
		let errors = {};
      	let formIsValid = true;
		
		if (!categoryTitle) {
			formIsValid = false;
			$('.errortab_name').html('<span class="errorspan">Please fill the field</span>');
		}
		
		
		this.setState({
			errors: errors
		});
		return formIsValid;
    }
	handleClickSelecetCategory = (event) => {
		const newCategoryId = event.target.value;
		console.log(newCategoryId,'new');
		this.setState({ category_id: newCategoryId });
	};
	
	handleChangeCategory = selectedCategory => {

		this.setState({ selectedCategory});
		this.setState({ categoryvalue : selectedCategory.value });
 	}
    

confirmPopup = (id, status) => {
	
  var status = status;

  if(status == 'I'){
	 status = "Inactive";
  }else if(status == 'A'){
	  status = "Active";
   
  }else{
    status="Delete";
  }
  

  this.setState({selectid: id, selectedStatus: status})	
  $('.confirm-action').addClass('show');		
}

listloadData(){
		var qs = require('qs');
		var catid = this.state.tabId;
		let admin_id = localStorage.getItem("admin_id");
			var qs = require('qs');
			var postObject = {             
			cat_id   :catid,
			admin_id :admin_id
		   
			};
		   
							axios.post(apiUrl + "jsonaifeed/listdetail", qs.stringify(postObject)).then(res => {
				if (res.data.status === 'success') {
					console.log(res.data.categories);  // 👈 check what is here
					const categoryData = res.data.categories[0];
					
					this.setState({
					categoryTitle: categoryData.category_title, // 👈 verify this exists
					fileList: categoryData.files,
					isCategory: true,
					expanded: false
					});
				}
				});

	}

deletejsonfile(){
  var qs = require('qs');
  var admin_id = localStorage.getItem("admin_id");
  var postObject = {
	id  : this.state.selectid,
	admin_id  : admin_id
  };
	  	let stat = ''
		if(this.state.selectedStatus ==='Delete'){
			stat = "D";
		} 

		var qs = require('qs');
		var postObject = {
		  admin_id : localStorage.getItem("admin_id"),
		  id  : this.state.selectid,
			  status: stat
		};
	  axios.post(apiUrl+"jsonaifeed/change_file_status", qs.stringify(postObject)).then(res => {
		if(res.data.status == "success"){
		  $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
		   this.listloadData()
		   setTimeout(
			function() {
			  $('.success_message').html('');
			}
			.bind(this),
			3000
			);
		}else{
		  $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
		}
	  });
  

}
activatejsonlist(){
  
		let stat = ''
		if(this.state.selectedStatus ==='Inactive'){
			stat = "I";
		}else{
			stat = "A";
		}  

		var qs = require('qs');
		var postObject = {
		  admin_id : localStorage.getItem("admin_id"),
		  id  : this.state.selectid,
			  status: stat
		};
	  axios.post(apiUrl+"jsonaifeed/change_file_status", qs.stringify(postObject)).then(res => {
		if(res.data.status == "success"){
		  $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
		   this.listloadData()
		   setTimeout(
			function() {
			  $('.success_message').html('');
			}
			.bind(this),
			3000
			);
		}else{
		  $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
		}
	  });
}
Confirmstatus = (confirmstatus) => {
  if(confirmstatus == 'yes'){
    if(this.state.selectedStatus=="Delete"){
      this.deletejsonfile()
    }else{
      this.activatejsonlist();
    }
    
    $('.confirm-action').removeClass('show');
  }else{
    $('.confirm-action').removeClass('show');	
  }
    
}

removeExistingFile = (index) => {
  const existingFiles = [...this.state.existingFiles];
  existingFiles.splice(index, 1);
  this.setState({ existingFiles });
}

onChangeHandler = (event) => {
  const files = Array.from(event.target.files); // selected files
  const previews = []; // to hold new previews
  let validFiles = [];

  files.forEach((file) => {
    // Validate file type — must be JSON
    if (file.type !== "application/json") {
      alert(`Invalid file type: ${file.name}. Only JSON files allowed.`);
      return;
    }

    validFiles.push(file);

    const reader = new FileReader();
    reader.onload = () => {
      previews.push({ name: file.name, content: reader.result });

      // When all files are loaded, update state
      if (previews.length === validFiles.length) {
        this.setState((prevState) => ({
          json_files: [...prevState.json_files, ...validFiles],         // append new files
          json_previews: [...prevState.json_previews, ...previews]      // append new previews
        }));
      }
    };

    reader.readAsText(file);
  });
};
removeFile = (index) => {
  const newFiles = [...this.state.json_files];
  const newPreviews = [...this.state.json_previews];

  newFiles.splice(index, 1);
  newPreviews.splice(index, 1);

  this.setState({
    json_files: newFiles,
    json_previews: newPreviews
  });
};
 render() {
  const navigate = this.props.navigate;
  const { selectedOption, tab_name, image_preview, image_name, isHidden, fileList, isCategory, categoryTitleInput, Loading } = this.state;

  return (
    <div className="wrapper">
		<div className="confirm-action">
			<p>Are you sure! you want to {this.state.selectedStatus} the Json File?</p>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		</div>
      <Header />
      <MenuSidebar currentpage="json" />
      <div className="content">
        <div className="content-wrapper">
          <div className="content-wrapper-before"></div>
          <div className="form-wrapper leaa-admin-head card">
            <div className="success_message"></div>
          	<div>
				<a class="btn" href="/json">Back</a>
			</div>
            <div className="title">
              <h4>Edit Details</h4>
            </div>

            <form className="edit" id="edit" onSubmit={e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
              <div className="form-row">
                <div className="form-left">
                  {/* Category Title input */}
                  {isCategory && (
                    <div className="form-group">
                      <label>Category Title <span className="required" style={{ color: "red" }}>*</span> :</label>
                      <input
                        type="text"
                        name="categoryTitleInput"
                        value={this.state.categoryTitle}
                        onChange={(e) => this.setState({ categoryTitle: e.target.value })}
                        className="form-control"
                      />
					  <div className="errortab_name"></div>
                    </div>

					
                  )}
				
				   
                </div>

				 <div className="form-right">
					<div className="form-group">
						<label>Upload Json file (allowed type: json only)<span className="required" style={{ color: "red" }} >* </span></label>
						<div className="choose-file">
						{this.state.isHidden && <div className="image_success"></div>}
						<span className="profile_btn">
							<input
							type="file"
							name="json_files"
							multiple
							accept=".json"
							onChange={this.onChangeHandler}
							/>
						</span>
						</div>
						<div className="errorimage"></div>
				  			<div className="preview-wrapper" style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
											{/* {this.state.existingFiles.map((file, index) => (
												<div key={'existing-' + index}
												style={{
													position: "relative",
													border: "1px solid #ddd",
													padding: "8px 12px",
													borderRadius: "6px",
													display: "flex",
													alignItems: "center",
													gap: "10px",
												}}
												>
											<img src={jsonImg} alt="JSON file" style={{ width: "24px", height: "24px" }} />
											<strong>{file.json_file}</strong>

											
											<span
												onClick={() => this.removeExistingFile(index)}
												style={{
												position: "absolute",
												top: "-5px",
												right: "-5px",
												background: "red",
												color: "white",
												borderRadius: "50%",
												width: "20px",
												height: "20px",
												textAlign: "center",
												lineHeight: "20px",
												cursor: "pointer",
												fontWeight: "bold",
												}}
											>
												×
											</span>
											</div>
										))} */}

										{/* New file previews */}
										{this.state.json_previews.map((file, index) => (
											<div key={'new-' + index}
											style={{
												position: "relative",
												border: "1px solid #ddd",
												padding: "8px 12px",
												borderRadius: "6px",
												display: "flex",
												alignItems: "center",
												gap: "10px",
											}}
											>
											<img src={jsonImg} alt="JSON file" style={{ width: "24px", height: "24px" }} />
											<strong>{file.name}</strong>
											<span
												onClick={() => this.removeFile(index)}
												style={{
												position: "absolute",
												top: "-5px",
												right: "-5px",
												background: "red",
												color: "white",
												borderRadius: "50%",
												width: "20px",
												height: "20px",
												textAlign: "center",
												lineHeight: "20px",
												cursor: "pointer",
												fontWeight: "bold",
												}}
											>
												×
											</span>
											</div>
										))}

										</div>

					</div>
				  		<div className="form-group">
								<label>
									<input
									type="checkbox"
									checked={this.state.functionalEndpoints}
									onChange={this.handleCheckboxChange}
									style={{ marginRight: '8px' }}
									/>
									Functional Endpoints
								</label>
								<br></br>
								<span>
									Hint: You are not allowed to remove the files
								</span>
								</div>

							
                </div>
				  		  {/* Files List */}
                  {fileList.length > 0 && (<>
                    <div className="form-group">
                      <label>Files :</label>
                      <div className="file-list-wrapper">
                       {fileList.map((file, index) => (
  						<div key={file.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
							{/* File name */}
							<span>{file.json_file}</span>
							{/* Status icon */}
							{file.status === 'A' ? (
							<span 
						onClick={this.confirmPopup.bind(this,file.id, 'I')}
						title="Active"
						style={{ cursor: 'pointer', marginRight: '12px', fontSize: '20px' }}
					>
						<i className="ft-unlock" aria-hidden="true"></i>
					</span>
					) : (
					<span 
						onClick={this.confirmPopup.bind(this,file.id, 'A')}
						title="Inactive"
						style={{ cursor: 'pointer', marginRight: '12px', fontSize: '20px' }}
					>
						<i className="ft-lock" aria-hidden="true"></i>
					</span>
					)}
					{!this.state.functionalEndpoints && (
					<span
						onClick={() => this.confirmPopup(file.id, 'D')}
								title="Delete"
								style={{ cursor: 'pointer', marginRight: '12px', fontSize: '20px' }}
								>
								<i
									className="ft-trash-2"
									aria-hidden="true"
									style={{
									color: file.status === 'D' ? 'red' : '#333'
									}}
								></i>
						</span>  )}

								{!this.state.functionalEndpoints && (
                                                <span style={{ cursor: 'pointer', marginRight: '12px', fontSize: '20px' }}>
                                                  <a
                                                    onClick={() => this.fetchJsonFileContent(file.json_file,file.id)}
                                                  >
                                                    <i className="ft-edit-3" aria-hidden="true"></i>
                                                  </a>
                                                </span>
                                              )}
							
						
  						</div>
				))}
						   
                      </div>
                    </div>
				{fileList.map((file, index) => (<>
					{this.state.editingFileName === file.json_file && (
						<div style={{ marginTop: '15px' }}>
						<ReactJson
							src={this.state.jsonContent}
							onEdit={this.state.functionalEndpoints ? false : (edit) => this.handleJsonEdit(edit)}
							onAdd={this.state.functionalEndpoints ? false : (add) => this.handleJsonEdit(add)}
							onDelete={this.state.functionalEndpoints ? false : (del) => this.handleJsonEdit(del)}
							// onEdit={(edit) => this.handleJsonEdit(edit)}
							// onAdd={(add) => this.handleJsonEdit(add)}
							// onDelete={(del) => this.handleJsonEdit(del)}
							theme="monokai"
							displayDataTypes={false}
							displayObjectSize={false}
							collapsed={1}
							className="json-text-editor"
							style={{ padding: '10px', borderRadius: '5px', background: '#2d2d2d' }}
							/>
						</div> 
						)}
						</>
					))}
					</>
                  )}

               
              </div>

              <div className="btn-group export">
                <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={Loading}>
                  {Loading ? <span>Updating</span> : <span>Submit</span>}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

}



export default (withRouter(Edit));